
import React from "react";
import { Link } from "react-router-dom";
import elementalLogo from "@/assets/elemental-value-logo.png";

const Header = () => {
  return (
    <header className="bg-white/90 backdrop-blur-sm shadow-sm">
      <div id="header" className="menu relative">
        <div className="menu-left">
          <Link to="/" aria-label="Elemental Value - Inicio" className="header-logo-link">
            <img src={elementalLogo} alt="Elemental Value" className="header-logo" />
          </Link>
        </div>
        <div id="myTopnav" className="topnav">
          <ul className="header-nav">
            <li className="y">
              <Link to="/" className="menu-item bg-[#EEFF30] text-gray-900">Home</Link>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Header;
